/*------------------------------------*\
    MODULES
\*------------------------------------*/
import getBreakpoint from "../helpers/get-breakpoint";
import clickOutside from 'click-outside';

/*------------------------------------*\
    SITE-HEAD
\*------------------------------------*/
class SiteHead {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.hamburger = self.elem.querySelector('[data-nav-toggle]');
        self.nav = self.elem.querySelector('[data-site-nav]');

        // Specify the breakpoints where the mobile nav is used.
        // If the $nav-breakpoint Sass variable is changed, this should be updated to match.
        self.mobileBreakpoints = ['xs', 'sm', 'md'];

        self.dropdowns = self.elem.querySelectorAll('[data-dropdown-item]');
    }

    init() {
        let self = this;

        if (self.nav) {
            self.navToggle();

            self.activePage();

            // Set the nav height
            self.setNavHeight();

            function runSetNavHeight() {
                self.setNavHeight();
            }

            this.dropdownsToggle();
        }


    }

    // Function to toggle nav visibility
    navToggle() {
        let self = this;

        const body = document.querySelector('body');

        self.hamburger.addEventListener('click', evt => {
            // Scroll the nav to the top
            self.elem.scrollTop = 0;

            // Toggle active class on toggle button
            self.hamburger.classList.toggle('is-active');

            // Toggle active class on nav
            self.nav.classList.toggle('is-active');

            // Toggle active class on site-head
            self.elem.classList.toggle('is-active');

            // Toggle scrolling on body
            body.classList.toggle('is-no-scroll');
        });
    }

    // set active class on menu item that is current page
    activePage() {
        let self = this;

        // console.log('URL', location.pathname);

        let path = location.pathname;
        let index = path.indexOf( '/', path.indexOf( '/' ) + 1 );
        path = path.substr(0, index) + '/';

        // console.log('PATH', path);

        let activeNav = self.nav.querySelector(`a[href='${path}']`);

        if(activeNav) {
            activeNav.classList.add('is-active');
        }
    }

    // Function to set the height of the nav panel on mobile
    setNavHeight() {
        let self = this;

        // Get the header height
        let headerHeight = self.elem.querySelector('[data-site-head-top]');

        if (self.mobileBreakpoints.includes(getBreakpoint())) {
            // If were are on mobile, set the nav height to 100vh minus the header height
            // self.nav.style.height = `calc(100vh - ${headerHeight.offsetHeight}px)`;
        } else {
            // If we're on desktop, set the header height to auto
            self.nav.style.height = 'auto';
        }
    }

    dropdownsToggle() {
        let self = this;

        Array.from(self.dropdowns).map(item => {
            let trigger = item.querySelector('[data-dropdown-trigger]');

            if (trigger !== null) {
                trigger.addEventListener('click', evt => {
                    evt.preventDefault();
                    if (item.classList.contains('is-open')) {
                        item.classList.remove('is-open');
                        trigger.setAttribute('aria-expanded', false);
                    } else {
                        item.classList.add('is-open');
                        trigger.setAttribute('aria-expanded', true);
                    }
                });

                clickOutside(trigger, () => {
                    item.classList.remove('is-open');
                    trigger.setAttribute('aria-expanded', false);
                });
            }
        });
    }
}

export default SiteHead;
